import LayoutWrapper from "../LayoutWrapper/LayoutWrapper";

const MinimalLayout = () => {
	return (
		<LayoutWrapper
			backgroundColor="var(--color-white)"
			showSideNav={false}
		></LayoutWrapper>
	);
};

export default MinimalLayout;
